/**
 * Download data as a JSON file
 * @param data - The data to be downloaded as JSON
 * @param filename - The name of the file (default: "data.json")
 * @param space - Number of spaces for JSON formatting (default: 2)
 */
export interface DownloadJSONOptions {
  data: unknown;
  filename?: string;
  space?: number;
}

export const downloadJSON = ({
  data,
  filename = "data.json",
  space = 2
}: DownloadJSONOptions): void => {
  try {
    if (!data) {
      console.error("No data provided for JSON download");
      return;
    }

    // Create JSON string with proper formatting
    const jsonString = JSON.stringify(data, null, space);

    // Create blob with proper MIME type
    const blob = new Blob([jsonString], {
      type: "application/json;charset=utf-8;"
    });

    // Create object URL
    const url = URL.createObjectURL(blob);

    // Create temporary link element
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;

    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("JSON download failed:", error);
  }
};
